const taskList = [];
let fetching = false;

export async function queue(task, delay) {
  return new Promise((resolve) => {
    addNewTask({ task, resolve, delay });
  });
}

function addNewTask(task) {
  taskList.push(task);
  executeNextTask();
}

async function executeNextTask() {
  if (fetching || !taskList.length) return;
  fetching = true;

  const { task, resolve, delay } = taskList.shift();
  const result = await task();

  await wait(delay || 500);
  resolve(result);
  fetching = false;
  executeNextTask();
}

const wait = (time) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};
